import { WebModuleDefinitionSchema, WebSurfaceDefinitionSchema } from '.';
export function createDefinition(definition) {
    const type = definition.type;
    switch (type) {
        case 'module': {
            return WebModuleDefinitionSchema.parse(definition);
        }
        case 'surface': {
            return WebSurfaceDefinitionSchema.parse(definition);
        }
    }
}
//# sourceMappingURL=definition.js.map